export default __webpack_public_path__ + "static/flat-cfa64ef797ba5573abf0405c1ced27bc.png";